export default __webpack_public_path__ + "img/bg-tab1and2_nav4-f3c40ed4.png";